module.exports = __webpack_public_path__ + "img/13_sanitation_(white).b68ede89.svg";